import React, {Component} from 'react';
import ReduxToastr from 'react-redux-toastr'
import {renderRoutes} from 'react-router-config'
import connect from 'react-redux/es/connect/connect';
import Helmet from 'react-helmet';
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';

import CookiesBanner from '../../components/CookiesBanner/CookiesBanner.jsx';
import CountryChoiceModal from '../../../shared/components/Modals/CountryChoiceModal/CountryChoiceModal.jsx';
import Errors from '../Errors/Errors.jsx';
import Loader from '../../../shared/components/Loader/Loader.jsx';
import Modals from '../../../shared/components/Modals/Modals.jsx';
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop.jsx';

import api from '../../../api.js';
import connectModal from '../../../shared/components/Modals/connect.js';
import {isAdmin} from '../../../shared/services/userService.js';
import loadSecteurs from '../../components/Secteurs/actions.js';
import {loadUser, setCurrentUser, setCurrentFreelance} from '../../components/CurrentUserLoader/actions.js';
import sharedConf from '../../../shared/conf.js';

const title = "Twineeds : Achats - Finance - Ressources humaines";
const description = "Twineeds met en relation les entreprises avec les consultants indépendants et les managers de " +
  "transition sur les fonctions Achats, Ressources humaines & Finance";

class App extends Component {
  constructor(props) {
    super(props);

    const alternatives = Object.values(sharedConf.sites).filter(
      (site) => site.languages.includes(navigator.language)
    );

    if (
      !sharedConf.sites[process.env.COUNTRY_SUBDOMAIN].languages.includes(navigator.language) &&
      alternatives.length !== 0
    ) {
      this.props.openCountryChoiceModal({
        alternativeUrl: alternatives[0].url,
        message: alternatives[0].redirectionMessage
      });
    }

    this.state = {
      cookiesAccepted: false
    };

    props.loadSecteurs();
    props.loadUser()
      .then((data) => {
        api.users.edit.on('success', this.onUserChange);
        api.freelances.edit.on('success', this.onFreelanceChange);
      })
    ;
    ReactGA.initialize(process.env.GOOGLE_ANALYTICS_API_KEY);
    ReactGA4.initialize(process.env.GA4_MEASUREMENT_ID, {testMode: process.env.NODE_ENV === 'dev'});
    this.updatePageView();
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if ((this.props.location.pathname !== prevProps.location.pathname) || (this.props.location.search !== prevProps.location.search)) {
      this.updatePageView();
    }
  }

  updatePageView() {
    if (window.location.search && window.location.search !== "") {
      ReactGA.pageview(window.location.pathname + "?" + window.location.search);
      ReactGA4.send({type: 'pageview', page: window.location.pathname + "?" + window.location.search});
    } else {
      ReactGA.pageview(window.location.pathname);
      ReactGA4.send({hitType: 'pageview', page: window.location.pathname});
    }
  }

  onUserChange = (response) => {
    const user = response.data;
    if (user.id === this.props.currentUser.id) {
      this.props.setCurrentUser(user);
    }
  };

  onFreelanceChange = (response) => {
    const freelance = response.data;

    if (this.props.currentFreelance && freelance.id === this.props.currentFreelance.id) {
      this.props.setCurrentFreelance(freelance);
    }
  };

  handleContextMenu = (e) => {
    if (!this.props.isAdmin) {
      e.preventDefault();
    }
  };

  onCookiesAccepted = () => {
    this.setState({cookiesAccepted: true});
  };

  render() {
    return (
      <div className="app" onContextMenu={this.handleContextMenu}>
        <Helmet>
          <meta name="description" content={description}/>
          <meta property="og:description" content={description}/>
          <meta property="og:title" content={title}/>
        </Helmet>
        {this.props.loader && !!this.props.loading ?
          <Loader visible={true}/> :
          renderRoutes(this.props.route.routes)
        }
        {!this.state.cookiesAccepted && <CookiesBanner onCookiesAccepted={this.onCookiesAccepted}/>}
        <Modals/>
        <ScrollToTop/>
        <Errors {...this.props} />
        <ReduxToastr
          timeOut={4000}
          newestOnTop={false}
          preventDuplicates={false}
          position="top-right"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar
        />
      </div>
    )
  }
}

export default connect(
  (state) => ({
    currentUser: state.currentUser.user,
    currentFreelance: state.currentUser.freelance,
    loading: state.currentUser.loading,
    loader: state.currentUser.loader,
    isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse)
  }),
  (dispatch) => ({
    loadUser: () => dispatch(loadUser()),
    loadSecteurs: () => dispatch(loadSecteurs()),
    setCurrentUser: (user) => dispatch(setCurrentUser(user)),
    setCurrentFreelance: (freelance) => dispatch(setCurrentFreelance(freelance))
  })
)(connectModal({CountryChoiceModal}, App));
